import { Slide, toast, ToastOptions } from 'react-toastify';

import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';

import { ClientsActionTypes } from 'api/clients/clients.action-types';
import styles from './notifications.module.scss';

export function success(message: string) {
  toast.success(message, {
    autoClose: 2000,
    className: styles.success,
    closeOnClick: true,
    hideProgressBar: true,
    pauseOnHover: true,
    position: 'top-right',
    transition: Slide,
  });
}

export function error(message: string) {
  toast.error(message, {
    autoClose: false,
    closeOnClick: true,
    hideProgressBar: true,
    pauseOnHover: true,
    position: 'top-right',
  });
}

export function progressBar(toastRef: number, progressLoaded: number, progressTotal: number, actionText: string) {
  const options: ToastOptions = {
    toastId: toastRef,
    className: styles.progressBar,
    autoClose: false,
    closeOnClick: false,
    hideProgressBar: true,
    pauseOnHover: false,
    position: 'top-right',
  };
  const progress = (progressLoaded / progressTotal) * 100;
  const progressFormatted = progress.toFixed(2);

  toast.info(`${actionText} in progress: ${progressFormatted}%\nDo not close this window or navigate away!`, options);

  if (toastRef && progress < 100) {
    toast.update(toastRef, {
      render: `${actionText} in progress: ${progressFormatted}%\nDo not close this window or navigate away!`,
    });
  }

  if (toastRef && progress === 100) {
    toast.update(toastRef, {
      render: `${actionText} complete! It is now safe to close this window or navigate to another page.`,
    });
  }
}

const notificationMessage = {
  [InternalActionTypes.UserCreated]: 'User created successfully!',
  [InternalActionTypes.UserEdited]: 'User updated successfully!',
  [InternalActionTypes.EventAssigned]: 'Event assigned!',
  [InternalActionTypes.EventCreated]: 'Event created!',
  [InternalActionTypes.EventEdited]: 'Event updated!',
  [InternalActionTypes.EventParticipantsUploaded]: 'Participants uploaded!',
  [InternalActionTypes.MergedParticipants]: 'Details copied!',
  [InternalActionTypes.ConvertedToUnknownParticipant]: 'Converted to unknown participant!',
  [InternalActionTypes.ClientCreated]: 'Client created!',
  [InternalActionTypes.EventTransitionLoaded]: 'Event state updated!',
  [InternalActionTypes.ShopCreated]: 'Shop created!',
  [InternalActionTypes.ClientEdited]: 'Client updated!',
  [InternalActionTypes.PasswordChanged]: 'Password successfully changed!',
  [InternalActionTypes.EventParticipantAdded]: 'Added participant',
  [InternalActionTypes.EventParticipantEdited]: 'Edited participant',
  [ClientsActionTypes.EDIT_CLIENT_USER_SUCCESS]: 'Client has been edited successfully',
  [InternalActionTypes.ParticipantVirtualGraduationAccepted]: 'Participant Virtual Graduation successfully approved',
  [InternalActionTypes.ParticipantVirtualGraduationRejected]: 'Participant Virtual Graduation successfully rejected',
  [InternalActionTypes.EventParticipantDeleted]: 'Participant has been deleted successfully',
  [InternalActionTypes.ParticipantBlacklistAdded]: 'Participant has been added to blacklist',
  [InternalActionTypes.ParticipantBlacklistRemoved]: 'Participant has been removed from blacklist',
  [InternalActionTypes.VideoReminderEmailSent]: 'Email has been sent',
  [InternalActionTypes.UserDeleted]: 'User has been deleted',
  [InternalActionTypes.EventArchived]: 'Event has been archived',
  [InternalActionTypes.EventUnarchived]: 'Event has been unarchived',
  [InternalActionTypes.ClientArchived]: 'Client has been archived',
  [InternalActionTypes.EventCancelled]: 'Event has been cancelled',
  [InternalActionTypes.ClientUnarchived]: 'Client has been unarchived',
  [InternalActionTypes.EmailPrevievSent]: 'Email preview has been sent',
  [InternalActionTypes.UnlockTemplate]: 'Template has been unlocked',
};

export function notifyOnAction(action: AllActions) {
  if (notificationMessage[action.type]) {
    success(notificationMessage[action.type]);
  }
}
